import { z } from 'zod';

export const UserDetailsSchema = z.object({
  UserId: z.string(),
  Role: z.string().min(1, { message: 'Please select a role' }),
});

// Schema for multi-role mode - expects array of option objects from multiselect
export const UserDetailsSchemaMultiRole = z.object({
  UserId: z.string(),
  Roles: z.array(
    z.object({
      value: z.string(),
      label: z.string(),
      description: z.string().optional(),
    })
  ),
  // COI-819 — support entitlement, rendered only for a CustomerSupport caller
  // editing a RiskSmart-internal user. Not part of `Roles`: it is not a custom
  // role and cannot be one (1785258221000 rejects internal role types in
  // `custom_role_assignment`), and it saves through its own procedure.
  // Optional so the field's absence for every other caller is not a validation
  // error.
  SupportAccess: z.boolean().optional(),
});

export type UserDetailsFormFields = z.infer<typeof UserDetailsSchema>;
export type UserDetailsFormFieldsMultiRole = z.infer<
  typeof UserDetailsSchemaMultiRole
>;
